import React from 'react';
import { InlineInput, INPUT_SIZES } from 'lib/input';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const StyledInlineInput = styled(InlineInput)`
  ${({ max, theme }) => css`
    flex-shrink: 0;
    margin-left: ${theme.size.spacing.medium.value};
    width: calc(28px + ${max.toString().length}ch);
  `}

  /* stylelint-disable */
  /* For removing up and down arrow buttons in input type number  */
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
    text-align: center;
  }
  /* stylelint-enable */
`;

const SliderInput = React.forwardRef(
  (
    {
      ariaLabel = 'Slider Input',
      dataTestId = '',
      disabled = false,
      id,
      isInputReadOnly = false,
      max = 100,
      min = 0,
      name,
      onChange,
      value,
      ...other
    },
    ref
  ) => {
    return (
      <StyledInlineInput
        data-testid={dataTestId ? `${dataTestId}-input` : undefined}
        id={id ? `${id}-input` : undefined}
        isDisabled={disabled}
        isReadOnly={isInputReadOnly}
        name={name ? `${name}-input` : undefined}
        {...{ max, min, onChange, value }}
        {...other}
        hideLabel
        ref={ref}
        size={INPUT_SIZES.STANDARD}
        type="number"
      />
    );
  }
);

SliderInput.propTypes = {
  /** Informs screen reader users what actions they should take */
  ariaLabel: PropTypes.node,
  /** Id value used for testing */
  dataTestId: PropTypes.string,
  /** If true, input is disabled and value of it cannot be edited */
  disabled: PropTypes.bool,
  /** Identifier of the input component */
  id: PropTypes.string.isRequired,
  /** If true, input is in read only state, value cannot be edited */
  isInputReadOnly: PropTypes.bool,
  /** Maximum value in the range of permitted values */
  max: PropTypes.number,
  /** Minimum value in the range of permitted values */
  min: PropTypes.number,
  /** Name of the input */
  name: PropTypes.string.isRequired,
  /** Callback to be called when input's value is being changed by user interaction */
  onChange: PropTypes.func.isRequired,
  /** Current value of the input field */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export { SliderInput };
